import type { RegionOption } from '../region-select-modal';

/** Global Zoho CRM MCP URLs by data center (from Zoho MCP team). */
export const ZOHO_MCP_REGION_OPTIONS = [
  {
    value: 'us',
    label: 'United States',
    description: 'crm.zohomcp.com',
    mcpUrl: 'https://crm.zohomcp.com/mcp/message',
  },
  {
    value: 'eu',
    label: 'Europe',
    description: 'crm.zohomcp.eu',
    mcpUrl: 'https://crm.zohomcp.eu/mcp/message',
  },
  {
    value: 'in',
    label: 'India',
    description: 'crm.zohomcp.in',
    mcpUrl: 'https://crm.zohomcp.in/mcp/message',
  },
  {
    value: 'au',
    label: 'Australia',
    description: 'crm.zohomcp.com.au',
    mcpUrl: 'https://crm.zohomcp.com.au/mcp/message',
  },
  {
    value: 'ca',
    label: 'Canada',
    description: 'crm.zohomcp.ca',
    mcpUrl: 'https://crm.zohomcp.ca/mcp/message',
  },
  {
    value: 'sa',
    label: 'Saudi Arabia',
    description: 'crm.zohomcp.sa',
    mcpUrl: 'https://crm.zohomcp.sa/mcp/message',
  },
  {
    value: 'jp',
    label: 'Japan',
    description: 'crm.zohomcp.jp',
    mcpUrl: 'https://crm.zohomcp.jp/mcp/message',
  },
  {
    value: 'ae',
    label: 'UAE',
    description: 'crm.zohomcp.ae',
    mcpUrl: 'https://crm.zohomcp.ae/mcp/message',
  },
] as const satisfies readonly RegionOption[];
